import Flex from 'typescript-styled-flex'
import styled from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

const LicenseWrapper = styled(Flex as any)<IWithSize & {more?:boolean}>`
  min-height: ${({ size }) => (size ? 65 * size : 65)}px;
    height: auto;
    padding-top: 5px;
    padding-bottom: 5px;
  width: ${({ size }) => (size ? 325 * size : 325)}px;


    font-family: Montserrat, sans-serif;
    font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  text-align: left;
    color: #272728;
  padding: ${({ size }) => (size ? 18 * size : 18)}px;
  // padding-right: ${({ size, more }) => more? 0:(size ? 5 * size : 5)}px;
  // padding-left: ${({ size, more }) => more?0:(size ? 17 * size : 17)}px;
`
export default LicenseWrapper
